import { Injectable } from '@angular/core';
import { EMPTY_ARRAY_LENGTH, FIRST_ELEMENT_INDEX, ISpreadSheet } from '@modeso/aumico-lib-core-fe';
import { IFasAccountValue } from '../../interfaces/fas-account-value.interface';

const ACCOUNT_NUMBER_COL_INDEX = 0;
const ACCOUNT_NAME_COL_INDEX = 1;
const COSTS_OPENING_COL_INDEX = 2;
const COSTS_ADDITIONS_COL_INDEX = 3;
const COSTS_DISPOSALS_COL_INDEX = 4;
const COSTS_TRANSFERS_COL_INDEX = 5;
const COSTS_CLOSING_COL_INDEX = 6;
const DEPRECIATION_OPENING_COL_INDEX = 7;
const DEPRECIATION_ADDITIONS_COL_INDEX = 8;
const DEPRECIATION_DISPOSALS_COL_INDEX = 9;
const DEPRECIATION_TRANSFERS_COL_INDEX = 10;
const DEPRECIATION_CLOSING_COL_INDEX = 11;
const VALUE_APPRECIATION_COL_OPENING = 12;

const MIN_EXPECTED_COLUMN_COUNT = 13;
const FAS_SHEET_NAME = 'Anlagenspiegel';

@Injectable()
export class FixedAssetsScheduleFileService {
    mapParsedFileToFasAccounts(parsedFile: ISpreadSheet): IFasAccountValue[] {
        const containsSheetWithTheCorrectNameIndex = parsedFile.sheets.findIndex(
            (sheet) => sheet.name === FAS_SHEET_NAME,
        );
        const fasSheet = parsedFile.sheets[containsSheetWithTheCorrectNameIndex];
        const fasAccounts: IFasAccountValue[] = [];
        let rowIndex = 0;
        for (const row of fasSheet.rows) {
            // skip first row of titles
            if (row == null || rowIndex == 0) {
                rowIndex = rowIndex + 1;
                continue;
            }

            fasAccounts.push({
                accountNumber: row.cells[ACCOUNT_NUMBER_COL_INDEX],
                accountName: row.cells[ACCOUNT_NAME_COL_INDEX],
                costs: {
                    openingValue: parseFloat(row.cells[COSTS_OPENING_COL_INDEX]),
                    additions: row.cells[COSTS_ADDITIONS_COL_INDEX]
                        ? parseFloat(row.cells[COSTS_ADDITIONS_COL_INDEX])
                        : null,
                    disposals: row.cells[COSTS_DISPOSALS_COL_INDEX]
                        ? parseFloat(row.cells[COSTS_DISPOSALS_COL_INDEX])
                        : null,
                    transfers: row.cells[COSTS_TRANSFERS_COL_INDEX]
                        ? parseFloat(row.cells[COSTS_TRANSFERS_COL_INDEX])
                        : null,
                    closingValue: row.cells[COSTS_CLOSING_COL_INDEX]
                        ? parseFloat(row.cells[COSTS_CLOSING_COL_INDEX])
                        : null,
                },
                depreciation: {
                    openingValue: parseFloat(row.cells[DEPRECIATION_OPENING_COL_INDEX]),
                    additions: row.cells[DEPRECIATION_ADDITIONS_COL_INDEX]
                        ? parseFloat(row.cells[DEPRECIATION_ADDITIONS_COL_INDEX])
                        : null,
                    disposals: row.cells[DEPRECIATION_DISPOSALS_COL_INDEX]
                        ? parseFloat(row.cells[DEPRECIATION_DISPOSALS_COL_INDEX])
                        : null,
                    transfers: row.cells[DEPRECIATION_TRANSFERS_COL_INDEX]
                        ? parseFloat(row.cells[DEPRECIATION_TRANSFERS_COL_INDEX])
                        : null,
                    closingValue: row.cells[DEPRECIATION_CLOSING_COL_INDEX]
                        ? parseFloat(row.cells[DEPRECIATION_CLOSING_COL_INDEX])
                        : null,
                },
                valueAppreciation: {
                    openingValue: parseFloat(row.cells[VALUE_APPRECIATION_COL_OPENING]),
                    closingValue: 0,
                },
            });

            rowIndex = rowIndex + 1;
        }
        return fasAccounts;
    }

    isUploadedFileValid(parsedFile: ISpreadSheet): boolean {
        const fasSheetWithTheCorrectNameIndex = parsedFile.sheets.findIndex((sheet) => sheet.name === FAS_SHEET_NAME);

        if (
            parsedFile.sheets == null ||
            parsedFile.sheets.length === EMPTY_ARRAY_LENGTH ||
            fasSheetWithTheCorrectNameIndex == null ||
            fasSheetWithTheCorrectNameIndex < EMPTY_ARRAY_LENGTH
        ) {
            return false;
        }

        const fasSheet = parsedFile.sheets[fasSheetWithTheCorrectNameIndex];

        if (fasSheet.rows.length === EMPTY_ARRAY_LENGTH) {
            return false;
        }

        const titleRow = fasSheet.rows[FIRST_ELEMENT_INDEX];

        if (titleRow.cells.length < MIN_EXPECTED_COLUMN_COUNT) {
            return false;
        }

        return true;
    }
}
